import { Box, Grid, styled, Typography, useTheme } from '@mui/material';
import { Container } from '@mui/system';
import qrImage from '../assets/footer-qr.png';
import Qkstudio from '../assets/icons/qkstudio-icon.jsx';
import config from '../config';

const PhoneWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '.5rem',
  },
}));

const Item = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  padding: '.1rem .75rem',
  borderRadius: '5px',
  lineHeight: '1.2',
  fontWeight: 500,
  fontSize: '.65rem',
}));

export default function Footer() {
  const theme = useTheme();
  return (
    <Container>
      <Grid
        container
        sx={{
          padding: '0 1.875rem',
          [theme.breakpoints.down('md')]: {
            justifyContent: 'center',
          },
        }}
      >
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            display: 'flex',
            [theme.breakpoints.down('md')]: {
              flexDirection: 'column',
              textAlign: 'center',
              marginBottom: '2rem',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              [theme.breakpoints.down('md')]: {
                justifyContent: 'center',
              },
            }}
          >
            <img src={qrImage} />
          </Box>
          <Box
            pl={{ xs: 2 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              [theme.breakpoints.down('md')]: {
                marginTop: '.5rem',
              },
            }}
          >
            <Typography
              sx={{ color: theme.palette.grey[400], fontSize: '.65rem' }}
            >
              © 2022 Municipalidad de San Miguel.
            </Typography>
            <Typography
              sx={{ color: theme.palette.grey[400], fontSize: '.65rem' }}
            >
              Buenos Aires. Argentina.
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly',
          }}
        >
          <PhoneWrapper>
            <Item>SAME</Item>
            <Item>107</Item>
          </PhoneWrapper>
          <PhoneWrapper>
            <Item>ATENCIÓN AL VECINO</Item>
            <Item>147</Item>
          </PhoneWrapper>
          <PhoneWrapper>
            <Item>COM</Item>
            <Item>109</Item>
          </PhoneWrapper>
          <PhoneWrapper>
            <Item>BOMBEROS</Item>
            <Item>(011) 4664-2222</Item>
          </PhoneWrapper>
          <PhoneWrapper>
            <Item>COMISARÍA DE LA MUJER</Item>
            <Item>4455-0371</Item>
          </PhoneWrapper>
        </Grid>
      </Grid>
    </Container>
  );
}
